import { ListItemButton, ListItemIcon, ListItemText, Typography } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import React from 'react';
import { isRouteSelected } from './sidebarNav';

/** @param depth 0 for a leaf directly under a product, 1+ for one inside a sub-group. */
const SidebarItem = ({ item, depth = 0 }) => {
  const location = useLocation();
  const nested = depth > 0;

  // Opt-in prefix matching, see `sidebarNav.isRouteSelected`.
  const selected = isRouteSelected(item, location.pathname);

  return item.sidebarProps && item.path ? (
    <ListItemButton
      component={Link}
      target={item.target}
      to={item.path}
      selected={selected}
      sx={{
        ...(!item.sidebarProps.icon && {
          borderLeft: theme => `${selected ? 3 : 1}px solid ${theme.palette.primary.main}`,
          ml: 2,
        }),
        px: 1,
      }}
    >
      {item.sidebarProps.icon && (
        <ListItemIcon
          sx={{
            ...(nested ? { minWidth: 32, mr: 1 } : { mr: 2 }),
            ...(selected && {
              color: theme => theme.palette.primary.main,
            }),
            justifyContent: 'center',
          }}
        >
          {item.sidebarProps.icon}
        </ListItemIcon>
      )}
      <ListItemText
        sx={{
          ...(item.sidebarProps.icon ? {} : { ml: 2 }),
          my: 0,
        }}
        primary={
          <Typography variant={nested ? 'body2' : 'body1'} fontWeight={selected && 'bold'}>
            {item.sidebarProps.displayText}
          </Typography>
        }
      />
    </ListItemButton>
  ) : null;
};

export default SidebarItem;
